import * as yup from 'yup';
import i18n from 'app-i18n';

// Password schema with custom match and i18n error
export const passwordSchema = () =>
  yup
    .string()
    .max(100)
    .matches(
      /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[<>{}"\\/|;:.,~!?@#$%^=&*\]()[_+-]).{12,}$/,
      () => i18n.t('forms.fields.password.errors.match'),
    )
    .required()
    .default('');

// Confirm password schema, referencing the password field
export const confirmPasswordSchema = (ref = 'password') =>
  yup
    .string()
    .oneOf([yup.ref(ref), null], () =>
      i18n.t('forms.fields.password.errors.confirmMatch'),
    )
    .required()
    .default('');
